<template>
  <b-row>
    <b-col>
        <div class="text-right">
          <button type="button"
                  class="btn btn-sm fa fa-sync fa-lg btn-link"
                  @click="clearFilters">
          </button>
          <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"
                    v-b-toggle.userdata_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
        </div>
        <div>
          <b-collapse id="userdata_search_collapse" class="mt-2">
            <ChatbotThreadsFiltering :idContractor="idContractor" @getPage="filterData" ref="chatbotThreadsFiltering"></ChatbotThreadsFiltering>
          </b-collapse>
        </div>
        <Loader v-if="isLoading"></Loader>
        <span v-else-if="!isLoading && items.length < 1">{{ $t('views.excmchatbot.list.noItems') }}</span>
        <table v-else class="table table-sm table-striped table-hover">
          <thead>
          <tr>
            <th>
                <span @click="changeOrder('createdAt')" class="th-link">
                  {{$t('views.excmchatbot.list.createdAt')}}
                </span>
              <i v-if="order['createdAt']" :class="{'fas fa-sort-down': order['createdAt'] === 'desc', 'fas fa-sort-up': order['createdAt'] === 'asc'}"></i>
            </th>
            <th>{{$t('views.excmchatbot.list.idContractor')}}</th>
            <th>{{$t('views.excmchatbot.list.emails')}}</th>
            <th>{{$t('views.excmchatbot.list.subject')}}</th>
            <th>
                <span @click="changeOrder('messagesQuantity')" class="th-link">
                  {{$t('views.excmchatbot.list.messageQuantity')}}
                </span>
              <i v-if="order['messagesQuantity']" :class="{'fas fa-sort-down': order['messagesQuantity'] === 'desc', 'fas fa-sort-up': order['messagesQuantity'] === 'asc'}"></i>
            </th>
            <th>
                <span @click="changeOrder('lastMessage.messageDateTime')" class="th-link">
                  {{$t('views.excmchatbot.list.lastMessageDate')}}
                </span>
              <i v-if="order['lastMessage.messageDateTime']" :class="{'fas fa-sort-down': order['lastMessage.messageDateTime'] === 'desc', 'fas fa-sort-up': order['lastMessage.messageDateTime'] === 'asc'}"></i>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in items"
            :key="item['@id']">
            <td>
              <span v-if="item.createdAt">{{ $moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss') }}</span>
            </td>
            <td>
              <router-link v-if="item.idContractor && item.idContractor.isCompany === 0" :to="{name: 'UserDataShow', params: { id: item.idContractor['@id'] }}">
                {{ item.idContractor.name }} {{ item.idContractor.surname }}
              </router-link>
              <router-link v-else-if="item.idContractor" :to="{name: 'FirmShow', params: { id: item.idContractor['@id'] }}">
                {{ item.idContractor.firmname1 === '' ? item.idContractor.fullName : item.idContractor.firmname1 }}
              </router-link>
            </td>
            <td>
              <a :href="'mailto: ' + item.userEmailFromApplication">{{item.userEmailFromApplication}}</a>
            </td>
            <td>
              <router-link :to="{name: 'EXCMChatbotThreadShow', params: { id: item['@id'] }}">
                {{ item.subject }}
              </router-link>
            </td>
            <td>{{ item.messages.length }}</td>
            <td v-if="item.messages.length > 0">{{ $moment(item.messages[item.messages.length - 1].messageDateTime).format('YYYY-MM-DD HH:mm:ss') }}</td>
            <td v-else> - </td>
          </tr>
          </tbody>
        </table>
        <pagination
          v-if="view"
          :view="view"
          @getPage="getPage"
        ></pagination>
    </b-col>
  </b-row>
</template>
<script>
import ChatbotThreadsFiltering from '@/components/Dashboard/Views/excmchatbot/components/ChatbotThreadsFiltering'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'
import { mapActions, mapGetters } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'ChatbotThreadsTable',
  components: { ChatbotThreadsFiltering, Loader, Pagination },
  data () {
    return {
      searchParams: {
        itemsPerPage: 10,
        state: 1,
        idContractor: this.idContractor
      },
      orderReference: {},
      order: {
        'lastMessage.messageDateTime': '',
        'messageDateTime': '',
        'messagesQuantity': ''
      }
    }
  },
  created () {
    this.orderReference = JSON.parse(JSON.stringify(this.order))
    let url = addParamsToQuery('e_x_c_m_chatbot_threads', this.searchParams)
    this.getPage(url)
  },
  methods: {
    ...mapActions({
      getPage: 'excmchatbot/list/default'
    }),
    changeOrder (property) {
      switch (this.order[property]) {
        case '':
          this.order[property] = 'asc'
          break
        case 'asc':
          this.order[property] = 'desc'
          break
        case 'desc':
          this.order[property] = ''
          break
      }
      this.filterData()
    },
    filterData (url = 'e_x_c_m_chatbot_threads') {
      let searchParams = {}
      Object.keys(this.order).forEach(property => {
        if (this.order[property]) {
          searchParams[`order[${property}]`] = this.order[property]
        } else {
          delete searchParams[`order[${property}]`]
        }
      })
      url = addParamsToQuery(url, searchParams)
      this.getPage(url)
    },
    clearFilters () {
      this.order = JSON.parse(JSON.stringify(this.orderReference))
      if (this.$refs.chatbotThreadsFiltering) {
        this.$refs.chatbotThreadsFiltering.clearFilters()
      }
    },
    getIdLink (link) {
      return getId(link)
    }
  },
  computed: {
    ...mapGetters({
      deletedItem: 'excmchatbot/del/deleted',
      error: 'excmchatbot/list/error',
      items: 'excmchatbot/list/items',
      isLoading: 'excmchatbot/list/isLoading',
      view: 'excmchatbot/list/view'
    })
  },
  props: {
    idContractor: {
      type: String,
      default: ''
    }
  }
}
</script>
